export default {
    apiKey: "AIzaSyB7Gh0EexLlFL2OZNQBit9bypoxIPiNY9c",
    authDomain: "the-dinah-media-1539257375472.firebaseapp.com",
    databaseURL: "https://the-dinah-media-1539257375472.firebaseio.com",
    projectId: "the-dinah-media--1539257375472",
    storageBucket: "the-dinah-media--1539257375472.appspot.com",
    messagingSenderId: "707121805386",
    timestampInSnapshots: true
}